<svg [ngClass]="class" viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg">
  <path d="M11.2812 0.947937L6.5 5.71877L1.71875 0.947937L0.25 2.41669L6.5 8.66669L12.75 2.41669L11.2812 0.947937Z"
        [style.fill]="fillColor"
  />
</svg>

